<div class="create-dashboard-root-div paddingtop-20px">
  <div class="title-heading-div">
    <h3>{{ this.pageDetail ? "Update Page" : "Create Page" }}</h3>
  </div>
  <div class="modal-body">
    <form class="modal-body-inner" [formGroup]="form">
      <div class="form-custom-div">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <app-input
              controlName="Title"
              [form]="form"
              label="Page Name"
              requiredMessage="Page Name is Required"
            ></app-input>
          </div>
          <!-- <div class="col-md-4 col-lg-4">
            <app-checkbox
              controlName="IsLandingPage"
              [form]="form"
              label="Is Landing Page"
              type="toggle"
            ></app-checkbox>
          </div> -->
          <div class="col-lg-12 col-md-12">
            <div class="form-group page-textarea-code-group">
              <div class="d-flex justify-content-between mb-2">
                <label class="mt-2" for="">Page Code</label>
                <div class="btn-group rounded">
                  <button
                    (click)="type = 'editor'"
                    type="button"
                    class="btn btn-sm btn-light"
                    [ngClass]="{ 'bg-primary-dark text-white': type === 'editor' }"
                  >
                    Editor
                  </button>
                  <button
                    (click)="type = 'builder'"
                    type="button"
                    class="btn btn-sm btn-light"
                    [ngClass]="{ 'bg-primary-dark text-white': type === 'builder' }"
                  >
                    Builder
                  </button>
                </div>
              </div>
              <div class="textarea-code-box" *ngIf="type === 'editor'">
                <ngx-codemirror
                  [options]="options"
                  [(ngModel)]="body"
                  [ngModelOptions]="{ standalone: true }"
                  [autoFocus]="true"
                ></ngx-codemirror>
              </div>
              <div *ngIf="type === 'builder'">
                <app-page-generator [(html)]="body"></app-page-generator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="modal-footer-bottom mt-2">
      <app-modal-action-btns
        [form]="form"
        [disabled]="form.invalid || !body"
        (onReject)="close()"
        (onConfirm)="onSubmit()"
        [useFormSubmit]="false"
      ></app-modal-action-btns>
    </div>
  </div>
  <div class="faq-section mt-4" *ngIf="isOgInsightsEnabled">
    <h4>FAQs</h4>
    <mat-accordion>
      <mat-expansion-panel hideToggle #faqPanel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="faq-chevron" [class.faq-chevron-expanded]="faqPanel.expanded"></span>
            How to embed OG Insights charts?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="faq-answer">
          <p>Click the Copy icon next to the desired chart in the OG Insights tab and paste it into the page, or add the chart ID to the code snippet:</p>
          <p class="faq-label">1. Dashboards</p>
          <pre><code>&lt;iframe src="{{ogInsightsUrl}}/embed/dashboard/&#123;OGInsights_Dashboard_Id&#125;"&gt;&lt;/iframe&gt;</code></pre>
          <p class="faq-label">2. Questions</p>
          <pre><code>&lt;iframe src="{{ogInsightsUrl}}/embed/question/&#123;OGInsights_Question_Id&#125;"&gt;&lt;/iframe&gt;</code></pre>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
